   
<template>
  <div class="market_left hk_stock">
    <!-- <div class="">
      <stock-chart></stock-chart>
    </div> -->
    <div class="divideSection"></div>
    <div>
      <el-row>
        <el-col :span="24" style="padding: 10px"> {{$t('pc.allhkstock.all_us_stocks')}} </el-col>
      </el-row>
    </div>
    <div class="wrap">
      <div class="main"
        v-loading="loading"
        :element-loading-text="$t('el.select.loading')"
       >
        <el-table
          :data="tableData"
          border
          stripe
          size="mini"
          style="width: 100%"
        >
          <el-table-column fixed align="center" :label="$t('pc.allhkstock.code')">
            <template slot-scope="scope">
              <router-link
                :to="{
                  name: 'Stockdetailed',
                  query: { symbol:  scope.row.short,
                    direction: $route.query.sort_field === 'shortTradingStocks' ? 1 : 0
                  },
                }"
                class="stockLinkColor"
              >
                <span>{{ scope.row.code }}</span>
              </router-link>
            </template>
          </el-table-column>
          <el-table-column fixed align="center" prop="name" :label="$t('pc.allhkstock.name')">
            <template slot-scope="scope">
              <router-link
                :to="{
                  name: 'Stockdetailed',
                  query: { symbol:  scope.row.short,
                    direction: $route.query.sort_field === 'shortTradingStocks' ? 1 : 0
                  },
                }"
                class="stockLinkColor"
              >
                <span
                  style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                  >{{ scope.row.name }}</span
                >
              </router-link>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="zhi1" :label="$t('pc.allhkstock.latest_price')">
          </el-table-column>
          <el-table-column align="center" prop="diff" :label="$t('pc.allhkstock.change')">
          </el-table-column>
          <el-table-column align="center" prop="chg" :label="$t('pc.allhkstock.rate_of_change')">
           
          </el-table-column>
          <!-- <el-table-column align="center" prop="buy" label="买入">
          </el-table-column>
          <el-table-column align="center" prop="sell" label="卖出">
          </el-table-column> -->
          <!-- <el-table-column
            align="center"
            prop="settlement"
            label="昨收">
          </el-table-column> -->
          <el-table-column align="center" prop="open" :label="$t('pc.allhkstock.opening_price')">
          </el-table-column>
          <el-table-column align="center" prop="high" :label="$t('pc.allhkstock.highest_price')">
          </el-table-column>
          <el-table-column align="center" prop="low" :label="$t('pc.allhkstock.lowest_price')">
          </el-table-column>
          <el-table-column align="center" prop="tradingVolume" :label="$t('pc.allhkstock.tradingVolume')">
          </el-table-column>
          <el-table-column align="center" prop="totalMarketValue" :label="$t('pc.allhkstock.totalMarketValue')">
          </el-table-column>
          <!--<el-table-column
            align="center"
            width="120"
            prop="volume"
            label="成交量/手">
            <template slot-scope="scope">
              <span>{{ scope.row.volume.toLocaleString() }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="120"
            prop="amount"
            label="成交额/万">
            <template slot-scope="scope">
              <span>{{ scope.row.amount.toLocaleString() }}</span>
            </template>
          </el-table-column>-->
        </el-table>
        <div class="pagination" v-if="total>pagesize">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="this.pagesize"
          >
          </el-pagination>
        </div>
        <div class="bottombar"></div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import StockChart from "@/components/stockchart";
export default {
  name: "AllHKStock",
  components: {
    StockChart,
  },
  data() {
    return {
      tableData: [],
      total: 40,
      currentPage: 1,
      pagesize: 40,
      sortField: '',
      sortOrder: '',
      loading: false, 
    };
  },
  methods: {
    get_all_stock() {
      let that = this;
      that.loading = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "all_stock",
            page: that.currentPage,
            num: that.pagesize,
            sort_field: that.sortField || '',
            sort_order: that.sortOrder || ''
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
              that.tableData = res.data.data;
              var last = that.tableData[that.tableData.length - 1];
              that.total = (last && last.total > 0) ? last.total : that.getTableCount();
            }
        })
        .catch((e) => {
        console.error(e);
        that.tableData = [];
      })
      .finally(() => {
        that.loading = false;  
      });
      },
    getTableCount() {
      let that = this;
      $.ajax({
        cache: true,
        url:
          "https://stock.finance.sina.com.cn/usstock/api/jsonp.php/fa8Vo3U4TzVRdsLs/US_CategoryService.getList?page=" +
          that.currentPage +
          "&num=" +
          that.pagesize,
        dataType: "jsonp",
        jsonpCallback: "fa8Vo3U4TzVRdsLs",
        success: function (data) {
          that.total=parseInt(data.count);
        },
      });
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.get_all_stock();
    },
    // getTableCount() {
    //   let that = this;
    //   $.ajax({
    //     cache: true,
    //     url:
    //       "https://vip.stock.finance.sina.com.cn/quotes_service/api/json_v2.php/Market_Center.getHKStockCount?node=qbgg_hk",
    //     type: "GET",
    //     dataType: "json",
    //     success: function (data) {
    //       that.total = parseInt(data);
    //     },
    //   });
    // }
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler(q) {
        let that = this;
        that.sortField = q.sort_field || '';
        that.sortOrder = q.sort_order || '';
        // if sort changed, reset to page 1
        if ((q.sort_field || q.sort_order) && that.currentPage !== 1) {
          that.currentPage = 1;
        }
        that.loading = true;
        that.get_all_stock();
      }
    }
  },
  mounted: function () {
    let that = this;
    that.sortField = that.$route.query.sort_field || '';
    that.sortOrder = that.$route.query.sort_order || '';
    that.currentPage = Number(that.$route.query.page) || 1;
    that.getTableCount();
    that.get_all_stock();
  },
};
</script>

<style scoped>
.hk_stock {
  border-left: 10px #f1f1f1 solid;
}
.divideSection {
  height: 10px;
  width: 1000px;
  background: #f1f1f1;
}

.main {
  margin-top: 10px;
}
.stockLinkColor {
  color: rgb(0, 0, 238);
}
.stockLinkColor :hover {
  color: #0100a0;
}
.green {
  color: #008000;
}
.bottombar {
  margin: 0 auto;
  text-align: center;
  padding-top: 10px;
}

.pagination {
  margin: 0 auto;
  text-align: center;
}

.market_left {
  width: 1000px;
  float: right;
  min-height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/AllHKStock.vue